import { MDBCol, MDBRow } from 'mdbreact';
import React, { useState } from 'react'
import { faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight, faBold, faItalic } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SubirImagenesContainer from '../../../SubirImagenes';
import { Image2, Search } from 'react-iconly';
const OpcionesMenuNavegacion = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;
    const [justify, setJustify] = useState(styles?.justify)
    const [header, setHeader] = useState(styles?.header)
    const [modal, setModal] = useState(false)
    const [urlImg, setUrlImg] = useState(styles?.urlImg)

    const modificarModal = () => {
        setModal(!modal)
    }

    const imagenActual = (img) => {
        handleEstilosComponente({ type, id, valor: img.path, nombre: 'urlImg' })
        setUrlImg(img.path)
        setModal(false)
    }

    return (
        <div>
            <div className='mb-2 '>
                <div className='d-flex align-items-center'>
                    <h4>Header</h4>
                    <div className="ml-2 custom-control custom-checkbox" onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.checked, nombre: 'header' }); setHeader(!header) }}>
                        <input type="checkbox" className="custom-control-input" id="header" defaultChecked={styles?.header} />
                        <label className="custom-control-label" htmlFor="header">Header</label>
                    </div>
                </div>

                {header ? <>
                    <MDBRow className='mb-2 '>
                        <MDBCol>
                            <div className='mb-2'>
                                <h6>Teléfono</h6>
                                <input
                                    defaultValue={styles?.whatsappHeader}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'whatsappHeader' })}
                                />
                            </div>

                        </MDBCol>
                        <MDBCol>
                            <div className='mb-2'>
                                <h6>Ubicación</h6>
                                <input
                                    defaultValue={styles?.correoHeader}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'correoHeader' })}
                                />
                            </div>
                        </MDBCol>
                    </MDBRow>
                    <MDBRow className='mb-2 '>
                        <MDBCol>
                            <div className='mb-2'>
                                <h6>Ubicación Texto Secundario</h6>
                                <input
                                    defaultValue={styles?.instagramHeader}
                                    type="text"
                                    className="form-control form-control-sm"
                                    onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'instagramHeader' })}
                                />
                            </div>

                        </MDBCol>

                        <MDBCol>
                            <div className='mb-2'>
                                <h6>Color Texto</h6>
                                <input
                                    type="color"
                                    id="exampleColorInput"
                                    value={styles?.textoSubMenu}
                                    onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'textoSubMenu' }); }}
                                    title="Choose your color"
                                />
                            </div>
                        </MDBCol>

                    </MDBRow>
                    <div className='mb-2 '>
                        <h6>Fondo </h6>
                        <MDBRow className='mb-2 titulo-button'>
                            <MDBCol>
                                <input
                                    type="color"
                                    id="exampleColorInput"
                                    value={styles?.backgroundSubMenu}
                                    onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'backgroundSubMenu' }); }}
                                    title="Choose your color"
                                />
                            </MDBCol>
                        </MDBRow>
                    </div>
                </> : null}

            </div>
            <hr />
            <div className='mb-2 '>
                <h4>Texto</h4>
                <MDBRow className='mb-2 titulo-button'>
                    <MDBCol>
                        <button className={justify == 'left' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'left', nombre: 'justify' }); setJustify('left') }} >
                            <FontAwesomeIcon icon={faAlignLeft} />
                        </button>
                        <button className={justify == 'center' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'center', nombre: 'justify' }); setJustify('center') }}>
                            <FontAwesomeIcon icon={faAlignCenter} />
                        </button>
                        <button className={justify == 'right' && 'boton-activo'} onClick={(e) => { handleEstilosComponente({ type, id, valor: 'right', nombre: 'justify' }); setJustify('right') }}>
                            <FontAwesomeIcon icon={faAlignRight} />
                        </button>

                        <input
                            type="color"
                            id="exampleColorInput"
                            value={styles?.textoMenu}
                            onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'textoMenu' }); }}
                            title="Choose your color"
                        />

                    </MDBCol>
                </MDBRow>
            </div>


            <div className='mb-2 '>
                <h4>Fondo </h4>
                <MDBRow className='mb-2 titulo-button'>
                    <MDBCol>
                        <input
                            type="color"
                            id="exampleColorInput"
                            value={styles?.textoMenu}
                            onChange={(e) => { handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'backgroundMenu' }); }}
                            title="Choose your color"
                        />
                    </MDBCol>
                </MDBRow>
            </div>
            <div className='mb-2'>
                <h4>Imagen</h4>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <h6>Ancho</h6>
                        <input
                            defaultValue={styles?.widthImg}
                            type="number"
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'widthImg' })}
                        />
                    </MDBCol>
                    <MDBCol>
                        <h6>Alto</h6>
                        <input
                            defaultValue={styles?.heightImg}
                            type="number"
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'heightImg' })}
                        />
                    </MDBCol>
                </MDBRow>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <h6>Sombra</h6>
                        <input
                            defaultValue={styles?.shadowsImg}
                            type="number"
                            placeholder='1 a 5'
                            min={0}
                            max={5}
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'shadowsImg' })}
                        />
                    </MDBCol>
                    <MDBCol>
                        <div className='d-flex align-items-cente mb-2'>
                            <h6 className='m-0'>Url Imagen</h6>
                            <a onClick={modificarModal}>
                                <Image2 className="ml-1" set="bold" />
                            </a>
                        </div>

                        <input
                            defaultValue={urlImg}
                            type="text"
                            disabled
                            className="form-control form-control-sm"
                            onChange={(e) => handleEstilosComponente({ type, id, valor: e.target.value, nombre: 'urlImg' })}
                        />
                    </MDBCol>
                </MDBRow>
            </div>
            <SubirImagenesContainer modal={modal} imagenActual={imagenActual} modificarModal={modificarModal} />
        </div>
    )
}

export default OpcionesMenuNavegacion